import React from 'react';
import { observer } from "mobx-react";
import PropTypes from 'prop-types';
import Icon from '../Icon';
import DateRange from '../DateRange';
import DatePick from '../DatePick';
import InputItem from '../InputItem';
import InputRage from '../InputRage';
import ButtonGroup from '../ButtonGroup';
import RefBox from '../RefBox';
import './style.less';

@observer
export default class SearchPlan extends React.Component {

  constructor(props) {
    super(props);
    // this.state = {
    //   items: props.items
    // }
  }

  handleChange = (code, value) => {
    // this.props.items.find(it => it.code === code).setValue(value);
    //console.log('items:', this.props)
    this.props.onChange && this.props.onChange(code, value, this.getValue(code, value));
  }

  getValue = (code, value) => {
    let _items = this.state.item;
    let it = item.find(it => it.code === code);
    if (it.component === 'refBox') {
      let refShowField = it.refShowField ? it.refShowField : '';
      const vs = (it.mode === 'single' ? [value] : value).map(it => {
        if (it) {
          let refValue = it.id;
          if (it.valueType.toLowerCase() === 'id') {
            refValue = it.id || it.ID || it.Id;
          }
          if (it.valueType.toLowerCase() === 'code') {
            refValue = it.code || it.Code;
          }
          if (it.valueType.toLowerCase() === 'name') {
            refValue = it.name || it.Name;
          }
          if (it.valueType.toLowerCase() === 'text') {
            refValue = it.Text || it.Name || it.Code || it.id || it.ID || it.Id || it.Value;
          }

          //处理refShowField为‘code+name’的情况
          let refShowFields = refShowField ? refShowField.split('+') : [];
          let texts = (refShowFields && refShowFields.length > 0) ? refShowFields.map(item => it[item]) : [];
          return {
            text: (texts && texts.length > 0) ? texts.join('/') : (it.$text || it.Name || refValue),
            value: refValue
          }
        } else {
          return {
            text: '',
            value: ''
          }
        }
      });
      if (it.mode === 'single') {
        return vs[0];
      } else {
        return vs;
      }
    } else {
      if (it.mode === 'single') {
        return {
          text: value.text,
          value: value.value
        }
      } else {
        return value.map(it => ({
          text: it.text,
          value: it.value
        }));
      }
    }
  }


  renderFilter = ({
    id,
    code,
    name,
    type,
    mode,
    component,
    value,
    visible,
    disabled,
    valueType,
    options
  }) => {
    let element;
    let opts = {
      id,
      visible,
      disabled,
      code,
      name,
      type,
      mode,
      valueType,
      name,
      ...options
    };
    let showLabel = true;
    switch (component) {

      case 'dateRange':
        //showLabel = false;
        element = (<DateRange onChange={v => this.handleChange(code, v)} value={value.map(it => it.value)} {...opts} />);
        break;
      case 'datePick':
        //showLabel = false;
        element = (<DatePick onChange={v => this.handleChange(code, v)} value={value && value.value} {...opts} />);
        break;
      case 'inputItem':
        element = (<InputItem onChange={v => this.handleChange(code, v)} value={value && value.value} {...opts} />);
        break;
      case 'inputRange':
        element = (<InputRage onChange={v => this.handleChange(code, v)} value={value.map(it => it.value)} {...opts} />);
        break;
      case 'buttonGroup':
        showLabel = false;
        element = (<ButtonGroup onChange={v => this.handleChange(code, v)} value={value && value.value} {...opts} />);
        break;
      case 'refBox':
        element = <RefBox value={value} {...opts} />;
        break;
      default:
        element = null;
        break;
    }
    return (<div key={code} className='filter'>
      {showLabel ? <label htmlFor={code}>{name}</label> : null}
      {element}
    </div>);
  }

  render() {
    // timetextbox 移动端不支持
    return (<div className='searchPlan'>
      {this.props.items.map(it => (this.renderFilter(it)))}
    </div>)
  }
}
